export default [{"url":"https://emekapromise-0.api.invexerp.io","name":"Branch 1","port":"5028","isStore":true,"isHQ":true}]